import React, { useEffect, useState } from 'react';
import { leadService } from '../../../services/leadService';

// Read-only view of memories saved before Moments existed. Nothing is changed or deleted.
export const LegacyMemories = ({ lead, user }) => {
  const [memories, setMemories] = useState([]);

  useEffect(() => {
    let active = true;
    leadService.getMemories(lead.id, user.id)
      .then((data) => { if (active) setMemories(data || []); })
      .catch(() => {});
    return () => { active = false; };
  }, [lead.id, user.id]);

  if (memories.length === 0) return null;

  return (
    <div className="pt-6 border-t border-slate-200">
      <h4 className="text-xs font-bold text-slate-500 uppercase tracking-wider">Earlier photos & memories</h4>
      <p className="text-xs text-slate-500 mt-1 mb-3">Saved before Moments. Kept as they were.</p>
      <div className="grid grid-cols-2 md:grid-cols-3 gap-3">
        {memories.map((m) => (
          <a
            key={m.id}
            href={m.signed_url}
            target="_blank"
            rel="noreferrer"
            className="block rounded-xl overflow-hidden bg-white border border-slate-200 shadow-sm"
          >
            <div className="aspect-square bg-slate-100">
              <img src={m.signed_url} alt={m.caption || 'Memory'} className="w-full h-full object-cover" loading="lazy" />
            </div>
            <div className="p-2">
              <p className="text-xs font-semibold text-slate-800 truncate">{m.caption || m.event_name || 'Memory'}</p>
              {m.memory_date && <p className="text-[10px] text-slate-400">{new Date(m.memory_date).toLocaleDateString()}</p>}
              {m.notes && <p className="text-[10px] text-slate-500 line-clamp-2 mt-1">{m.notes}</p>}
            </div>
          </a>
        ))}
      </div>
    </div>
  );
};